<script>
import BaseFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';
import { WarehouseDevicesService } from '@/services/warehouse-devices.service';

export default {
  name: 'SerialNumbersFilter',

  extends: BaseFilter,

  data() {
    return {
      name: 'serial_number'
    };
  },

  methods: {
    getData() {
      return WarehouseDevicesService.getFilteredSerialNumbers({
        search: this.search
      })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
